<template>
    <div class="slogan">
        {{ $t('devis.devis_voyage.title[0]') }}
        <span class="font-weight-bold">{{ $t('devis.devis_voyage.title[1]') }}</span
        >{{ $t('devis.devis_voyage.title[2]') }}
        <span class="font-weight-bold">{{ $t('devis.devis_voyage.title[3]') }}</span>
    </div>
</template>

<script>
    export default {
        name: 'Slogan'
    }
</script>

<style scoped>
    .slogan {
        text-align: center;
        color: #ffa409;
        font-size: 25px;
        font-weight: 300;
        margin: 5rem auto 3.8rem;
    }
</style>